import React, { useState } from "react";
import { Modal } from "antd";
import { useSelector, useDispatch } from "react-redux";
import { updateDisplayUndoNoShowBookingModal } from "../../../reducer/bookingReducer";
import { CircularProgress } from "@mui/material";
import useAllBookingFunction from "../../../hooks/bookingCustomHook/useAllBookingFunction";
import { IoIosCloseCircle } from "react-icons/io";

const UndoNoShowBookingModal = () => {
  const { displayUndoNoShowBookingModal, bookingDetails } = useSelector(
    (store) => store.booking
  );

  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  const { handleUndoCheckIn } = useAllBookingFunction(setLoading);

  const handleClose = () => {
    dispatch(updateDisplayUndoNoShowBookingModal(false));
  };

  return (
    <Modal
      open={displayUndoNoShowBookingModal}
      centered
      title=""
      width={"auto"}
      styles={{ mask: { backdropFilter: "blur(2px)" } }}
      onCancel={handleClose}
      footer={
        <div className="w-[100%] flex gap-2 justify-center mt-5 font-body">
          <button
            className="text-[16px] w-[11rem] h-[3rem] border-[1px]
            border-danger text-danger rounded-[0.5rem] font-[500] "
            onClick={handleClose}
          >
            NO
          </button>

          <button
            className="text-fg-inverse text-[16px] rounded-xl  bg-danger 
            w-[11rem] h-[3rem] font-[600]"
            onClick={loading ? undefined : handleUndoCheckIn}
          >
            {loading ? (
              <CircularProgress size={24} color="inherit" />
            ) : (
              <div>YES</div>
            )}
          </button>
        </div>
      }
      closable={false}
    >
      <div className="flex items-center gap-4 font-body">
        <div className="w-[38px] h-[38px] rounded-[8px] bg-danger-light flex justify-center items-center">
          <IoIosCloseCircle className="text-danger text-[22px]" />
        </div>
        <span className=" text-[21px] font-[600] text-danger">
          Undo{" "}
          {bookingDetails?.status === "noShow" ? "No Show" : "Booking Cancel"}
        </span>
      </div>
      <div className="text-fg  text-[18px] font-[500] pt-3">
        Are you sure you want to undo <br />
        {bookingDetails?.status === "noShow"
          ? "No Show Booking?"
          : "Cancelled Booking?"}
      </div>
    </Modal>
  );
};

export default UndoNoShowBookingModal;
